import http from '../http'

export class IpAddressController {
    #apiUrl
    #ipAddress

    constructor (from) {
        this.#apiUrl = `${from}/v1/get-ip-address`
    }

    async fetchFromAPi () {
        try {
            // Goes through the BFF like every other API call (withCredentials).
            const response = await http.get(this.#apiUrl)
            this.#ipAddress = response.data.ip
        } catch (error) {
            console.log('error', error)
        }
    }

    getIpAddress () {
        return this.#ipAddress
    }
}
